/**
 * SearchControl
 *
 * View that deals with interactions in the search control. This includes;
 * validating the selected date and time, redirecting to private dining and
 * getting new results.
 *
 * @return {view}
 */

OT.createNS('OT.Redesign.Views');

OT.Redesign.Views.SearchControl = OT.Search.Views.SearchControl.extend({
    el: '#search_control',

    initialize: function () {
        var self = this;
        self.$dtp = self.$(".dtp-picker");

        // README: will need to uncomment this code once in place
        // re-rendering from dtp is re-enabled
        //
        // OT.Events.on("dtp:search", function (e, data) {
        //     if (self.$dtp[0] === data.sender[0]) {
        //         self.performSearch(data);
        //         e.preventDefault();
        //     }
        // });
    },

    performSearch: function (data) {
        var covers = data.covers;
        var dateTime = data.datetime;

        this.invokeSearch(dateTime, covers);
    },

    invokeSearch: function (dateTime, covers) {
        OT.Search.Params.set({
            DateTime: dateTime,
            Covers: covers,
            OnlyUnavailable: null,
            From: null,
            IntersperseAvailability: null
        });

        if (covers === '21') {
            this.redirectToPrivateDining(dateTime);
        } else {
            this.submitNewSearch();
        }
    },

    /**
    * Redirect the user to the Private Dining page
    */
    redirectToPrivateDining: function(dateTime) {
        var url = OT.Search.Data.get().Display.LargePartySearchUrl + dateTime;

        // Fire a log event
        OT.Search.sendLogRequest('_PrivateDining', 'interaction', {});

        OT.Common.Helpers.redirectWindow(url);
    }
});
